import { parse } from 'date-fns';
import React, {useState, useEffect} from 'react'
// reactstrap components
import {
    Card,
    CardTitle,
    CardHeader,
    CardBody,    
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
    UncontrolledTooltip,
  } from "reactstrap";


  const baseFormData = [{
    "resort_code": "",
    "own_code": null,
    "resort_name": "",
    "own_name": null,
    "opk_type": "podstawowy",
    "group_id": null,
    "cost_type": "stale",
    "duration_calc": false
}]

const OPKForm = ({opk_list, group_code, dataSubmit, deleteOPK, notify, filtered}) => {
    const [FormData, setFormData] = useState([...baseFormData])

    useEffect(() => {
        setFormData([...opk_list])
    }, [opk_list])

    const handleFieldChange = (e) => {
        const itemID = parseInt(e.target.id.split('-')[1])
        const itemName = e.target.id.split('-')[0]
        const itemValue = e.target.value
        setFormData((prevState) => {
            let newState = [...prevState]
            newState[itemID][`${itemName}`] = itemValue
            return(newState)
        })
        updateOPKnumber(e.target.id, itemValue)
    }

    const updateOPKnumber = (fieldId, newVal) =>{
        let opkIndex = ['group_id','resort_code','own_code'].findIndex(element => element===fieldId.split('-')[0])
        if(opkIndex!==-1){
            let rowIndex = fieldId.split('-')[1]
            let new_opk_number = FormData[rowIndex].opk_number.split('-')
            new_opk_number[opkIndex] = opkIndex===0?group_code.filter(opk=>opk.id==newVal)[0].group_number:newVal
            setFormData((prevState) => {
                let newState = [...prevState]
                newState[rowIndex]['opk_number'] = new_opk_number.join('-')
                return(newState)
            })
        }
    }

    const handleSubmit = (id) => {
        // e.preventDefault();
        // const itemID = parseInt(e.target.id)
        const itemID = id
        const filtredFormItem = FormData.filter(dataItem => dataItem.id === itemID)[0]
        let itemToSubmit = {}
        Object.keys(baseFormData[0]).map(key =>{
            itemToSubmit[key] = filtredFormItem[key]
        })

        let errorMessage = []
        //validation
        if(errorMessage.length!==0){
            notify(errorMessage.join(' '))
        }else{
            dataSubmit(itemID, itemToSubmit)
        }
    }

    const handleDelete = (id) => {
        if (window.confirm('Czy na pewno chcesz usunąć ten OPK? Operacja jest nieodwracalna')) {
            console.log('delete', id)
            deleteOPK(id)
        }
    }

    const getColName = () =>{
        let dict = {
            'zarząd': '',
            'podstawowy':'Rodzaj kosztów',
            'proceduralny':'Typ rozliczenia kosztów',
            'pomocniczy medyczny':'Rodzaj kosztów',
            'pomocniczy niemedyczny':'Rodzaj kosztów',
        }
        return Object.keys(dict).includes(filtered)?dict[filtered]:'Rodzaj kosztów/Typ rozliczenia kosztów'
    }

    
    return (
        <div style={{margin: '0 15px'}}>
        <Row className={'row-margin'}  style={{alignItems: 'flex-end'}} >
            <Col sm={5}>
                <Row className={' text-center'} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                    <Col sm={3}> Kod syntetyczny </Col>
                    <Col sm={3}> Kod resortowy </Col>
                    <Col sm={3}> Kod własny </Col>
                    <Col sm={3}> Typ OPK </Col>
                </Row>
            </Col>

            <Col sm={7} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                <Row className={'text-center'} style={{alignItems: 'flex-end'}} >
                    <Col sm={3}> Numer OPK </Col>
                    <Col sm={5}> Nazwa OPK </Col>
                    <Col sm={2}> {getColName()} </Col>
                    <Col sm={2}> Akcja </Col>
                </Row>
            </Col>
        </Row>
        {FormData.map((opk_item, opk_idx) => {
                return (
                    <Form key={opk_idx} id={opk_item.id} className="">
                    <Row className={'row-margin'}>
                        <Col sm={5}>
                            <Row className={''}>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`group_id-${opk_idx}`} className='sr-only'>Kod syntetyczny</label>
                                        <Input
                                        // disabled={!opk_item.user_added}
                                        value={opk_item.group_id} 
                                        type="select" 
                                        name="select" 
                                        id={`group_id-${opk_idx}`}
                                        onChange={(e) => handleFieldChange(e)}
                                        >
                                            {group_code.sort((first, second)=> {
                                                        return first.group_number - second.group_number;
                                                        }).map((groupCodeItem, codeIdx )=>{
                                                return(
                                                    <option key={codeIdx} value={groupCodeItem.id}>{`${groupCodeItem.group_number}`}</option>
                                                )
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`resort_code-${opk_idx}`} className='sr-only'>Kod resortowy</label>
                                        <Input
                                            // disabled={!opk_item.user_added}
                                            id={`resort_code-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.resort_code}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`own_code-${opk_idx}`} className='sr-only'>Kod własny</label>
                                        <Input
                                            // disabled={!opk_item.user_added}
                                            id={`own_code-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.own_code}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`opk_type-${opk_idx}`} className='sr-only'>Typ OPK</label>
                                        <Input 
                                            value={opk_item.opk_type} 
                                            type="select"
                                            // disabled={!opk_item.user_added}
                                            name="select" 
                                            id={`opk_type-${opk_idx}`}
                                            onChange={(e) => handleFieldChange(e)}
                                        >
                                            <option value={"podstawowy"}>podstawowy</option>
                                            <option value={"proceduralny"}>proceduralny</option>
                                            <option value={"pomocniczy medyczny"}>pomocniczy medyczny</option>
                                            <option value={"pomocniczy niemedyczny"}>pomocniczy niemedyczny</option>
                                            <option value={"zarząd"}>zarząd</option>
                                        </Input>
                                    </FormGroup>
                                    <UncontrolledTooltip
                                        delay={0}
                                        placement="bottom"
                                        target={`opk_type-${opk_idx}`}
                                    >
                                        {opk_item.opk_type}
                                    </UncontrolledTooltip>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={7}>
                            <Row className={'row-margin'}>
                                <Col sm={2}>
                                    <FormGroup>
                                        <label htmlFor={`opk_number-${opk_idx}`} className='sr-only'>Numer OPK</label>
                                        <Input 
                                            id={`opk_number-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.opk_number}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup>
                                        <label htmlFor={`resort_name-${opk_idx}`} className='sr-only'>Nazwa OPK</label>
                                        <Input
                                            disabled={!(!opk_item.base_opk || opk_item.user_added)}
                                            id={`resort_name-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.resort_name}
                                            onChange={(e) => handleFieldChange(e)}    
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={2}>
                                    {opk_item.opk_type!=='zarząd'&&<>
                                        {opk_item.opk_type==='proceduralny'? 
                                            <FormGroup>
                                                <label htmlFor={`duration_calc-${opk_idx}`} className='sr-only'>Typ rozliczenia kosztów</label>
                                                <Input
                                                    value={opk_item.duration_calc}
                                                    type="select"
                                                    name="select"
                                                    id={`duration_calc-${opk_idx}`}
                                                    onChange={(e) => handleFieldChange(e)}
                                                >
                                                    <option value={false}>w oparciu o jednostkę kalkulacyjną</option>
                                                    <option value={true}>proporcjonalnie do czasu trwania procedur medycznych</option>
                                                </Input>
                                                {/* <UncontrolledTooltip
                                                    delay={0}
                                                    placement="bottom"
                                                    target={`duration_calc-add`}
                                                >
                                                    {formValues.duration_calc? <>proporcjonalnie do czasu trwania procedur medycznych</>: <>w oparciu o jednostkę kalkulacyjną</>}
                                                </UncontrolledTooltip> */}
                                            </FormGroup>:
                                            <FormGroup>
                                                <label htmlFor={`cost_type-${opk_idx}`} className='sr-only'>Rodzaj kosztów</label>
                                                <Input
                                                    value={opk_item.cost_type}
                                                    type="select"
                                                    name="select"
                                                    id={`cost_type-${opk_idx}`}
                                                    onChange={(e) => handleFieldChange(e)}
                                                >
                                                    <option value={"stale"}>stałe</option>
                                                    <option value={"zmienne"}>zmienne</option>
                                                    {/* <option value={"brak"}>brak</option> */}
                                                </Input>
                                            </FormGroup>
                                        }
                                    </>}
                                </Col>
                                <Col sm={2}>
                                    <div style={{display: 'flex'}}>
                                        <div>
                                            <Button
                                                className="btn-link mr-1"
                                                color="import"
                                                data-toggle="tooltip"
                                                id={`save-${opk_idx}`}
                                                style={{marginTop:"0px"}}
                                                type="button"
                                                onClick={(e) => handleSubmit(opk_item.id)}
                                                aria-label='Zapisz'
                                            >
                                                <i className="far fa-save fa-2x"></i>
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target={`save-${opk_idx}`}
                                            >
                                                Zapisz
                                            </UncontrolledTooltip>
                                        </div>
                                        <div>
                                            <Button
                                                className="btn-link mr-1"
                                                color="import"
                                                data-toggle="tooltip"
                                                id={`delete-${opk_idx}`}
                                                style={{marginTop:"0px"}}
                                                type="button"
                                                onClick={(e) => handleDelete(opk_item.id)}
                                                aria-label='Usuń'
                                            >
                                                <i className="fa fa-trash fa-2x"></i>
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target={`delete-${opk_idx}`}
                                            >
                                                Usuń
                                            </UncontrolledTooltip>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </Form>
                )
            })}
            
        </div>
    )
}

export default OPKForm
